// src/store/mySlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedProduct: {}
};

const productsSlice = createSlice({
  name: 'productsSlice',
  initialState,
  reducers: {
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    }
  },
});

export const { setSelectedProduct } = productsSlice.actions;

export default productsSlice.reducer;
